import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { PostSubscriptionActionEnum } from 'app/shared/enums/post-subscription-action.enum';
import { RTCEvent } from 'app/shared/enums/rtc-event.enum';
import { ChannelNameHelperService } from 'app/shared/services/message-bus/channel-name-helper.service';
import {
  MESSAGE_BUS_SERVICE, MessageBusService
} from 'app/shared/services/message-bus/message-bus-service.interface';
import { RealTimeEvent } from 'app/shared/services/message-bus/real-time-event.model';

import { GameShowRepository } from './gameshow-repository.interface';
import { GameShowRunClosedEvent } from './models/gameshow-run-closed-event';
import { GameShowRunLaunchedEvent } from './models/gameshow-run-launched-event';

@Injectable({
  providedIn: 'root'
})
export class KhGameShowStorageService implements GameShowRepository {
  private readonly messageBusService = inject<MessageBusService>(MESSAGE_BUS_SERVICE);

  public getActiveGameShowActivityId(classId: string): Observable<string | null> {
    const channel = ChannelNameHelperService.getClassesChannelName(classId);

    return this.messageBusService.connect(channel, PostSubscriptionActionEnum.FindPreSubGameShowRun)
      .pipe(
        filter((e) => e.id !== null),
        filter((e) => e.name === RTCEvent.GameShowLaunched || e.name === RTCEvent.GameShowUpdated),
        map((rtEvent: RealTimeEvent) => {
          if (rtEvent.messageObject) {
            // Handle GameShowLaunched event
            if (rtEvent.name === RTCEvent.GameShowLaunched) {
              return (rtEvent.messageObject as GameShowRunLaunchedEvent).activityId;
            }

            // Handle GameShowUpdated event (for close)
            if (rtEvent.name === RTCEvent.GameShowUpdated && (rtEvent.messageObject as GameShowRunClosedEvent).isGameShowRunClosed) {
              return null; // Gameshow closed, clear the ID
            }
          }

          return null;
        }));
  }
}
